<template>
  <transition name="note">
    <ul v-if="show_notes && notes.length" class="notes">
      <li v-for="(note, index) in notes" :key="note.id" class="relative n_li">
        <a
          :key="note.id"
          :href="note.data.link"
          :class="{ bold: !note.read_at }"
          class="dropdown-item"
          @click="markRead(note)"
          >{{ note.data.message }}</a
        >
        <button @click="destory(note, index)" class="no-btn close">&times;</button>
      </li>
    </ul>
    <ul class="notes" v-if="show_notes && !notes.length" @click="$emit('close')">
      <li class="n_li">
        <a href="#!">თქვენ არ გაქვთ შეტყობინებები</a>
      </li>
    </ul>
  </transition>
</template>

<script>
export default {
  props: ['show_notes'],
  data() {
    return {
      notes: [],
      user: window.App.user,
    };
  },
  methods: {
    markRead(note) {
      axios.put('/notifications/' + note.id);
    },
    destory(note, index) {
      axios
        .delete('/notifications/' + note.id)
        .then((res) => console.log(res))
        .catch((errors) => console.log(errors));
      this.notes.splice(index, 1);
    },
    fetchNotes() {
      axios.get('/notifications').then((res) => (this.notes = res.data));
    },
  },
  mounted() {
    this.fetchNotes();
  },
};
</script>
